import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import {
  Button,
  Typography,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../components/headers/DashboardHeader";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Icon } from "@iconify/react";
import { user_change_password } from "../DAL/auth/auth";

function PasswordField({ label, name, value, onChange, required }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      required={required}
      name={name}
      value={value}
      onChange={onChange}
      autoComplete="new-password"
      type={showPassword ? "text" : "password"}
      InputLabelProps={{
        shrink: Boolean(value),
      }}
      sx={{ mt: 1 }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword((prev) => !prev)}
              edge="end"
            >
              <Icon icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

function ChangePasswordPage() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    oldPassword: "",
    password: "",
    repeatPassword: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputs.password !== inputs.repeatPassword) {
      enqueueSnackbar("Password and Confirm Password do not match.", {
        variant: "error",
      });
      return;
    }
    setIsLoading(true);
    const postData = {
      old_password: inputs.oldPassword,
      new_password: inputs.password,
      confirm_password: inputs.repeatPassword,
    };
    const result = await user_change_password(postData);
    if (result.code === 200) {
      enqueueSnackbar("Password Changed Successfully", { variant: "success" });
      setInputs({ oldPassword: "", password: "", repeatPassword: "" });
      navigate("/dashboard");
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (!localStorage.getItem("code-verified")) {
      navigate("/login", { replace: true });
    }
  }, []);

  return (
    <>
      <div style={{ minHeight: "100vh", width: "100%" }}>
        <div className="header-container">
          <DashboardHeader />
        </div>
        <div className="container">
          {/* Page Title Row */}
          <div className="text-center mt-3 d-flex flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <IconButton onClick={() => navigate("/dashboard")}>
                <ArrowBackIcon sx={{ fontSize: 20, color: "#15978a" }} />
              </IconButton>
            </div>
            <div>
              <h2 className="primary-color mb-2">Change Password</h2>
              <p className="mb-0">
                Enhance your account security by setting a new password
              </p>
            </div>
            <div style={{ width: "40px" }}></div>
          </div>

          {/* Card */}
          <div
            className="card shadow-sm border-0"
            style={{
              borderRadius: "20px",
              backgroundColor: "white",
              boxShadow: "0 10px 40px rgba(0,0,0,0.1) !important",
              maxWidth: "700px",
              margin: "0 auto 40px",
            }}
          >
            <div
              className="card-body"
              style={{ padding: "40px 30px 30px 30px" }}
            >
              <form onSubmit={handleSubmit}>
                <div className="d-flex flex-column gap-3">
                  <PasswordField
                    label="Old Password"
                    name="oldPassword"
                    value={inputs.oldPassword}
                    onChange={handleChange}
                    required
                  />
                  <PasswordField
                    label="New Password"
                    name="password"
                    value={inputs.password}
                    onChange={handleChange}
                    required
                  />
                  <PasswordField
                    label="Confirm Password"
                    name="repeatPassword"
                    value={inputs.repeatPassword}
                    onChange={handleChange}
                    required
                  />

                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Change Password"
                      )}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePasswordPage;
